export default "/images/vendor/flag-icon-css/flags/4x3/sx.svg?aafb13f61b6688f41a14c976d908b855";